/**
 * A custom directive to handle cell country code changes.
 *
 * TODO: read http://stackoverflow.com/questions/14049480/what-are-the-nuances-of-scope-prototypal-prototypical-inheritance-in-angularjs
 */
App.directive('ngWhoisCountryFilter', ['whoisHelper', 'formHelper', function(whoisHelper, formHelper) {
    return {
        require: 'ngModel',
        link: function(scope, elem, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            void 0;
            void 0;
            void 0;

            /**
             * Watch out for change of the country code. This will trigger
             * resetting the whois_phone field.
             */
            elem.on('change', function(evt) {
                scope.$apply(function() {
                    var formName;

                    void 0;

                    // set the number placeholder (returns cell number validation bool)
                    whoisHelper.resetPhoneField(scope, ngModel, elem, evt);

                    // if validation is now failing, update validity of the
                    // whois_phone field in a hacky way (ewwwww...)
                    if (!whoisHelper.validateText(scope, ngModel, elem, evt)) {
                        formHelper.setError(scope, 'whois_phone', 'ngWhoisCountryFilter', true, true);
                    } else {
                        formHelper.clearError(scope, 'whois_phone');
                    }
                });
            });
        }
    }
}]);
